// frontend/src/components/Dashboard/DashboardSidebar.js
//
// Menú de navegación lateral del panel de administración. Reemplaza la fila
// de botones que abrían modales de pantalla completa: ahora cada sección
// (Empresas, Stacks, Logs, Notificaciones) vive en su propia página dentro
// de .dashboard-main, y solo los formularios de crear/editar siguen siendo
// modales (ver Dashboard.js).

import React from 'react';
import { Home, Users, Building2, Layers, ScrollText, Bell, Inbox, ChevronsLeft, ChevronsRight } from 'lucide-react';
import './DashboardSidebar.css';

const ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: Home },
  { key: 'candidatos', label: 'Candidatos', icon: Users },
  { key: 'empresas', label: 'Empresas', icon: Building2 },
  { key: 'stacks', label: 'Stacks sugeridos', icon: Layers },
  { key: 'logs', label: 'Logs', icon: ScrollText },
  { key: 'notificaciones', label: 'Notificaciones', icon: Bell },
  { key: 'solicitudes', label: 'Solicitudes demo', icon: Inbox }
];

// badges: { [key]: número } para mostrar un contador junto a la sección
// (p. ej. solicitudes de demo nuevas).
const DashboardSidebar = ({ vista, onNavegar, colapsado, onToggle, badges = {} }) => {
  return (
    <aside className={`dashboard-sidebar ${colapsado ? 'dashboard-sidebar-colapsado' : ''}`}>
      <nav className="dashboard-sidebar-nav">
        {ITEMS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            type="button"
            className={`dashboard-sidebar-item ${vista === key ? 'active' : ''}`}
            onClick={() => onNavegar(key)}
            title={colapsado ? label : undefined}
          >
            <Icon size={18} />
            <span>{label}</span>
            {badges[key] > 0 && (
              <em className="dashboard-sidebar-badge" aria-label={`${badges[key]} pendientes`}>
                {badges[key] > 99 ? '99+' : badges[key]}
              </em>
            )}
          </button>
        ))}
      </nav>
      <button
        type="button"
        className="dashboard-sidebar-toggle"
        onClick={onToggle}
        title={colapsado ? 'Expandir menú' : 'Ocultar menú'}
      >
        {colapsado ? <ChevronsRight size={16} /> : <ChevronsLeft size={16} />}
        <span>Ocultar menú</span>
      </button>
    </aside>
  );
};

export default DashboardSidebar;
